import React from "react";

function ArchivePoslovniProcesi(props) {
  return <div>archive poslovni procesi</div>;
}

export default ArchivePoslovniProcesi;
